"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactCta() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const buttonRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!buttonRef.current) return;
    const button = buttonRef.current;
    let shimmerInterval: NodeJS.Timeout;
    const addShimmer = () => {
      button.classList.add("shimmer-effect");
      setTimeout(() => {
        button.classList.remove("shimmer-effect");
      }, 1200);
    };
    shimmerInterval = setInterval(addShimmer, 4000);
    return () => {
      clearInterval(shimmerInterval);
    };
  }, []);
  return <section id="contact-cta" ref={sectionRef} className="dark bg-background text-foreground relative overflow-hidden py-16 px-4">
      <div className="absolute inset-0 bg-gradient-to-br from-[hsl(215,70%,12%)] via-[hsl(210,70%,18%)] to-[hsl(215,70%,10%)]" />
      
      <div className={`relative z-10 max-w-4xl mx-auto text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <p className="text-white/90 text-lg md:text-xl mb-2 font-sans tracking-wide">
          Ready to source quality commodities globally?
        </p>
        
        <div ref={buttonRef} className="inline-block my-6 relative">
          <Link to="/ContactPage">
            <Button size="lg" className="btn-primary text-lg px-10 py-4 shadow-strong relative overflow-hidden">
              Contact Us
            </Button>
          </Link>
        </div>
        
        <p className="text-white/80 text-base md:text-lg font-sans">
          Get started with transparent procurement and reliable logistics today.
        </p>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%) skewX(-15deg);
          }
          100% {
            transform: translateX(200%) skewX(-15deg);
          }
        }

        .shimmer-effect::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.3),
            transparent
          );
          animation: shimmer 1.2s ease-in-out;
          pointer-events: none;
        }
      `}</style>
    </section>;
}